import "./tokens.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { initPostHog } from "./posthog";

initPostHog();

// BrowserRouter : server.js ne renvoie index.html que pour « / ». Toute autre
// URL appelée directement (rechargement, lien partagé) répond 404 côté serveur.
ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root"));

  
